<script setup>
import { useTemplateRef, watch, getCurrentInstance, ref, markRaw, computed } from 'vue';
import { useElementVisibility } from '@vueuse/core'
import {
    phoneCountryOrder,
    isInternationalStore,
    getPhoneDefaultCountry,
} from '@js/utilities/phoneCountries';

const props = defineProps({
    errors: {},
    inputOptions: {
        type: Object,
        default: () => ({})
    },
    // Etykieta pola; domyslnie "Telefon" z tlumaczen (np. 'Numer telefonu *' dla wymaganego).
    label: {
        type: String,
        default: null
    }
})

// Z inputOptions.id etykieta wskazuje sam input (nazwa dostepna pola). Bez niego
// zostaje stare id="phone" na wrapperze - tak jak dotad w checkoucie i innych formularzach.
const labelTarget = props.inputOptions.id || 'phone'

const [model] = defineModel()

const preferredCountries = phoneCountryOrder

// On the .com store we let the widget guess the country from IP, everywhere else
// the market decides, so an unlisted region (at, ua) no longer falls back to the visitor's IP.
const isInternational = isInternationalStore()

const getDefaultCountry = () => (isInternational ? '' : getPhoneDefaultCountry())

// Prop inputOptions nadpisuje domyslne opcje biblioteki w calosci (bez scalania),
// wiec te, na ktorych nam zalezy, podajemy tu wprost. name/required/autocomplete
// zostawiamy wywolujacemu - bez nich atrybuty ladowaly na wrapperze, nie na inpucie.
// computed, zeby atrybuty zalezne od stanu (np. aria-invalid) trafialy na input na biezaco.
const inputOptions = computed(() => ({
    type: 'tel',
    maxlength: 25,
    placeholder: '',
    ...props.inputOptions
}))

const phoneRef = useTemplateRef('phoneElement')
const phoneVisible = useElementVisibility(phoneRef)
// const instance = getCurrentInstance();
const AsyncComponent = ref(null)
let arePhoneComponentAssetsLoaded = false;

watch(() => phoneVisible.value, async (value) => {
    if (value && !arePhoneComponentAssetsLoaded) {
        arePhoneComponentAssetsLoaded = true;
        // const appContext = instance?.appContext.app;

        await import('vue-tel-input/vue-tel-input.css');
        const { VueTelInput } = await import('vue-tel-input');
        // appContext.component('VueTelInput', VueTelInput);

        AsyncComponent.value = markRaw(VueTelInput);
    }
})

</script>

<template>
    <div class="form-floating is-invalid" ref="phoneElement" style="height:58px;">
        <component v-if="AsyncComponent" :is="AsyncComponent" v-model="model" :id="props.inputOptions.id ? undefined : 'phone'" class="form-control"
            :class="{ 'is-invalid': props.errors }" mode="international" :preferredCountries="preferredCountries"
            :inputOptions="inputOptions" :defaultCountry="getDefaultCountry()"
            :autoDefaultCountry="isInternational" />
        <label :for="labelTarget" class="form-label">{{ label || $t('global.phone') }}</label>
    </div>
</template>

<style>
.vue-tel-input:not(.is-invalid) {
    border-color: var(--bs-border-color) !important;
}

.vti__dropdown-list {
    z-index: 1000 !important;
}
</style>
